import ct from 'countries-and-timezones'
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advancedFormat);

const deductTimezoneOffset = (targetOffset) => {
    const currentDate = dayjs()
    const offsetDifference = targetOffset - currentDate.utcOffset()
    return offsetDifference;
}

export const getOffsetForLocation = (stateCode = null) => {
    if (!stateCode) return dayjs().utcOffset()
    const tZString = USA_STATE_CODE_TO_TIME_ZONE.get(stateCode);
    let timezoneDetails = ct.getTimezone(tZString)
    return deductTimezoneOffset(timezoneDetails?.dstOffset)
}

export function getTimeZoneWithAbbreviation(stateCode) {
    if (stateCode) {
        const tZString = USA_STATE_CODE_TO_TIME_ZONE.get(stateCode);
        if (tZString) {
            const date = dayjs().tz(tZString);
            return `${tZString?.replace(/_/g, ' ')} ${date.format('z')}`;
        }
    } else {
        return `${dayjs.tz.guess()?.replace(/_/g, ' ')} ${dayjs()?.format('z')}`;
    }
}

export function getTimeZoneAbbreviation(stateCode) {
    if (stateCode) {
        const tZString = USA_STATE_CODE_TO_TIME_ZONE.get(stateCode);
        if (tZString) {
            const date = dayjs().tz(tZString);
            return `${date.format('z')}`;
        }
    } else {
        return `${dayjs()?.format('z')}`;
    }
}

export const parseUTCToTimeZone = ({
    utcDateTime = "",
    stateCode = "",
    timezone = "",
  }) => {
    if (stateCode) {
      timezone = USA_STATE_CODE_TO_TIME_ZONE.get(stateCode);
    }
  
    let convertedJSDate = new Date(utcDateTime);
  
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: timezone,
    };
  
    const dateTimeFormat = new Intl.DateTimeFormat("en-US", options);
    const [
      { value: month },
      ,
      { value: day },
      ,
      { value: year },
      ,
      { value: hour },
      ,
      { value: minute },
    ] = dateTimeFormat.formatToParts(convertedJSDate);
    const timezoneParsedString = `${year}-${month}-${day} ${hour}:${minute}`;
  
    const finalParsedDate = dayjs.tz(timezoneParsedString, timezone);
    return finalParsedDate;
    // let parsedDate = dayjs.utc(utcDateTime).tz(timezone);
  
    // return parsedDate;
  };
  
  

export const USA_STATE_CODE_TO_TIME_ZONE = new Map([
    ["AL", "America/Chicago"],
    ["AK", "America/Anchorage"],
    ["AZ", "America/Phoenix"],
    ["AR", "America/Chicago"],
    ["CA", "America/Los_Angeles"],
    ["CO", "America/Denver"],
    ["CT", "America/New_York"],
    ["DE", "America/New_York"],
    ["FL", "America/New_York"],
    ["GA", "America/New_York"],
    ["HI", "Pacific/Honolulu"],
    ["ID", "America/Denver"],
    ["IL", "America/Chicago"],
    ["IN", "America/Indiana/Indianapolis"],
    ["IA", "America/Chicago"],
    ["KS", "America/Chicago"],
    ["KY", "America/New_York"],
    ["LA", "America/Chicago"],
    ["ME", "America/New_York"],
    ["MD", "America/New_York"],
    ["MA", "America/New_York"],
    ["MI", "America/New_York"],
    ["MN", "America/Chicago"],
    ["MS", "America/Chicago"],
    ["MO", "America/Chicago"],
    ["MT", "America/Denver"],
    ["NE", "America/Chicago"],
    ["NV", "America/Los_Angeles"],
    ["NH", "America/New_York"],
    ["NJ", "America/New_York"],
    ["NM", "America/Denver"],
    ["NY", "America/New_York"],
    ["NC", "America/New_York"],
    ["ND", "America/Chicago"],
    ["OH", "America/New_York"],
    ["OK", "America/Chicago"],
    ["OR", "America/Los_Angeles"],
    ["PA", "America/New_York"],
    ["RI", "America/New_York"],
    ["SC", "America/New_York"],
    ["SD", "America/Chicago"],
    ["TN", "America/Chicago"],
    ["TX", "America/Chicago"],
    ["UT", "America/Denver"],
    ["VT", "America/New_York"],
    ["VA", "America/New_York"],
    ["WA", "America/Los_Angeles"],
    ["WV", "America/New_York"],
    ["WI", "America/Chicago"],
    ["WY", "America/Denver"],
    ["AS", "Pacific/Pago_Pago"],
    ["DC", "America/New_York"], // District Of Columbia
    ["FM", "Pacific/Pohnpei"],  // Federated States Of Micronesia
    ["GU", "Pacific/Guam"],     // Guam
    ["MH", "Pacific/Majuro"],   // Marshall Islands
    ["MP", "Pacific/Saipan"],   // Northern Mariana Islands
    ["PW", "Pacific/Palau"],    // Palau
    ["PR", "America/Puerto_Rico"], // Puerto Rico
    ["VI", "America/St_Thomas"]    // Virgin Islands
]);
